import React from 'react';
import { useTranslation } from 'react-i18next';
import DetailsCard from '@common/components/General/DetailsCard';
import CustomAlert from '@common/components/Feedback/CustomAlert';
import useCustomLocalizationEffect from '../../../hooks/useCustomLocalizationEffect';
import { AlertColor } from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import CustomLocalizationType from '../../../models/enums/custom-localization-type';

const CleaningDataAlerts: React.FC<{
  titleKey: string;
  category: CustomLocalizationType;
  alerts: string[];
}> = ({ titleKey, category, alerts }) => {
  const { t } = useTranslation();
  const localize = useCustomLocalizationEffect();

  const mapCategoryToAlertSeverity = (category: CustomLocalizationType): AlertColor => {
    switch (category) {
      case CustomLocalizationType.WARNING_CODE:
        return 'info';
      case CustomLocalizationType.MAINTENANCE_CODE:
        return 'warning';
      case CustomLocalizationType.ERROR_CODE:
        return 'error';
      default:
        return 'info';
    }
  };

  const distinctAlerts = Array.from(new Set<string>(alerts));

  return (
    <DetailsCard
      cardTitle={t(titleKey)}
      enableContentHiding
      defaultHidden={distinctAlerts.length === 0}
    >
      <Stack spacing={1} pb={1}>
        {distinctAlerts.length === 0 ? (
          <CustomAlert severity="info" header={t('no-' + titleKey)} />
        ) : (
          distinctAlerts.map((a) => (
            <CustomAlert
              key={a}
              severity={mapCategoryToAlertSeverity(category)}
              header={localize(a, category)}
              textMessages={
                localize(a, category, true) ? [localize(a, category, true) ?? ''] : undefined
              }
            />
          ))
        )}
      </Stack>
    </DetailsCard>
  );
};

export default CleaningDataAlerts;
